import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../shared/constants/routes";
import { loginUser } from "../api/authApi";
import { setAuthUser } from "../utils/authStorage";
import { getDashboardByRole } from "../utils/roleRedirect";
import { Colors } from "../../utils/Colors";

export default function LoginPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const validate = () => {
    if (!form.email.trim()) {
      alert("Email is required");
      return false;
    }

    if (!/\S+@\S+\.\S+/.test(form.email)) {
      alert("Please enter a valid email");
      return false;
    }

    if (!form.password.trim()) {
      alert("Password is required");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setLoading(true);

      const data = await loginUser({
        email: form.email,
        password: form.password,
      });

      if (!data?.user) {
        alert("Login failed");
        return;
      }

      setAuthUser(data.user);
      alert(data.message || "Login successful");

      navigate(getDashboardByRole(data.user.role), { replace: true });
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        "Invalid email or password";

      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: Colors.bg.app,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "430px",
          background: Colors.bg.paper,
          borderRadius: "20px",
          boxShadow: Colors.shadow.brand,
          border: `1px solid ${Colors.border.light}`,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "8px",
            background: Colors.brand.accentBar,
            width: "100%",
          }}
        />

        <div style={{ padding: "32px" }}>
          <h1
            style={{
              margin: 0,
              marginBottom: "8px",
              color: Colors.text.title,
              textAlign: "center",
              fontSize: "30px",
              fontWeight: "800",
            }}
          >
            Login
          </h1>

          <p
            style={{
              marginTop: 0,
              marginBottom: "24px",
              textAlign: "center",
              color: Colors.text.muted,
              fontSize: "14px",
            }}
          >
            Enter your email and password to continue
          </p>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "16px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: Colors.text.body,
                  fontWeight: "600",
                }}
              >
                Email
              </label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter email"
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: `1px solid ${Colors.border.input}`,
                  outline: "none",
                  boxSizing: "border-box",
                  color: Colors.text.body,
                }}
              />
            </div>

            <div style={{ marginBottom: "18px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: Colors.text.body,
                  fontWeight: "600",
                }}
              >
                Password
              </label>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter password"
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: `1px solid ${Colors.border.input}`,
                  outline: "none",
                  boxSizing: "border-box",
                  color: Colors.text.body,
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "13px",
                borderRadius: "12px",
                border: "none",
                background: Colors.brand.primary,
                color: "#fff",
                fontWeight: "700",
                fontSize: "15px",
                cursor: "pointer",
              }}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>

          <p
            style={{
              marginTop: "18px",
              textAlign: "center",
              color: Colors.text.muted,
              fontSize: "14px",
            }}
          >
            Don&apos;t have an account?{" "}
            <span
              onClick={() => navigate(ROUTES.AUTH_SIGNUP)}
              style={{
                color: Colors.brand.primary,
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              Sign up
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}